import { kpRequest, kpEndpoint, kpParams } from '@/axios'

// Collection Related Actions
export const GET_COLLECTION_LIST = 'getCollectionList'
export const GET_COLLECTION_BY_ID = 'getCollectionById'
export const GET_UPCOMING_DEADLINE_COLLECTIONS = 'getUpcomingDeadlineCollections'
export const CREATE_COLLECTION = 'createCollection'
export const UPDATE_COLLECTION = 'updateCollection'
export const REORDER_COLLECTION = 'reorderCollection'
export const DELTE_COLLECTION = 'deleteCollection'
export const DOWNLOAD_COLLECTION = 'downloadCollection'
export const SYNC_COLLECTION_WITH_SHOPIFY = 'syncCollection'

// Product Related Actions
export const FETCH_COLLECTION_PRODUCTS = 'fetchCollectionProducts'
export const FETCH_COLLECTION_PRODUCT_BY_ID = 'fetchCollectionProductById'
export const FETCH_COLLECTION_PRODUCT_FILTERS = 'fetchCollectionProductFilters'
export const FETCH_DISCOVER_PRODUCTS = 'fetchDiscoverProducts'
export const DELETE_COLLECTION_PRODUCT = 'deleteCollectionProduct'
export const GET_RELATED_PRODUCTS = 'getRelatedProducts'
export const GET_PRODUCTS_IDS = 'getProductIds'

// Price book related actions
export const LOAD_PRICE_BOOKS = 'loadPriceBooks'
export const GET_PRICE_BOOK = 'getPriceBook'
export const IMPORT_PRICE_BOOK = 'importPriceBook'
export const CREATE_PRICE_BOOK = 'createPriceBook'
export const SET_PRICE_BOOKS = 'setPriceBooks'

// Currency book related actions
export const UPDATE_CURRENCIES = 'updateCurrencies'
export const EXPORT_CURRENCIES = 'exportCurrencies'
export const IMPORT_CURRENCIES = 'importCurrencies'

// Segmentation book related actions
export const CREATE_SEGMENTATION = 'createSegmentation'
export const EXPORT_SEGMENTATION = 'exportSegmentation'
export const IMPORT_SEGMENTATION = 'importSegmentation'
export const GET_SEGMENTATION_BOOKS = 'getSegmentationBooks'
export const DELETE_SEGMENTATION_BOOK = 'deleteSegmentation'
export const RENAME_SEGMENTATION = 'renameSegmentation'
export const DELETE_PRICEBOOK = 'deletePricebook'
export const RENAME_PRICEBOOK = 'importMasterPricebook'
export const DOWNLOAD_MASTER_SEGMENTATION_BOOK = 'downloadMasterSegmentationBook'
export const SET_IS_UPLOADING_CURRENCY_BOOK = 'setIsUploadingCurrencyBook'

// pricebook related actions
export const DOWNLOAD_MASTER_PRICEBOOK = 'downloadMasterPricebook'

// availability related actions
export const DOWNLOAD_AVAILABILITY = 'downloadAvailability'

const state = {
    priceBooks: [],
    isUploadingCurrencyBook: false,
}

export const mutations = {
    [SET_PRICE_BOOKS](state, priceBooks) {
        state.priceBooks = priceBooks
    },
    [SET_IS_UPLOADING_CURRENCY_BOOK](state, isUploadingCurrencyBook) {
        state.isUploadingCurrencyBook = isUploadingCurrencyBook
    },
}

export const actions = {
  // Collection Related Apis
  async [GET_COLLECTION_LIST](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.catalog.get, params })
  },
  async [GET_COLLECTION_BY_ID](ctx, collectionId) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.getById, collectionId),
    })
  },
  async [GET_UPCOMING_DEADLINE_COLLECTIONS](ctx, params = {}) {
    return await kpRequest({
      ...kpEndpoint.catalog.getUpcomingdeadlines,
      params,
    })
  },
  async [GET_COLLECTION_LIST](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.catalog.get, params })
  },
  async [CREATE_COLLECTION](ctx, { payload = {}, loaderObj = {} }) {
    return await kpRequest({
      ...kpEndpoint.catalog.create,
      payload,
      ...loaderObj,
    })
  },
  async [UPDATE_COLLECTION](
    ctx,
    { collectionId, payload = {}, loaderObj = {} },
  ) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.update, collectionId),
      payload,
      ...loaderObj,
    })
  },
  async [REORDER_COLLECTION](ctx, { collectionId, orderIndex }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.reorder, collectionId),
      payload: { orderIndex },
    })
  },
  async [DELTE_COLLECTION](ctx, { collectionId, params = {}, skipErrorToast = false }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.delete, collectionId),
      params,
      skipErrorToast,
    })
  },

  // Product Related Apis
  async [FETCH_COLLECTION_PRODUCTS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.product.list, params })
  },
  async [GET_PRODUCTS_IDS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.product.ids, params })
  },
  async [FETCH_COLLECTION_PRODUCT_BY_ID](ctx, { productId, params = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.product.getById, productId),
      params,
    })
  },
  async [FETCH_COLLECTION_PRODUCT_FILTERS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.product.filter, params })
  },
  async [FETCH_DISCOVER_PRODUCTS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.product.browse, params })
  },
  async [DELETE_COLLECTION_PRODUCT](ctx, { productId, params = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.product.deleteProduct, productId),
      params,
    })
  },
  async [GET_RELATED_PRODUCTS](ctx, { productId, params = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.product.relatedProducts, productId),
      params,
    })
  },
  async [DOWNLOAD_COLLECTION](ctx, { payload = {}, params }) {
    return await kpRequest({
      ...kpEndpoint.downloads.collection,
      payload,
      params,
    })
  },
  async [DOWNLOAD_AVAILABILITY](ctx, { payload = {} }) {
    return await kpRequest({
      ...kpEndpoint.downloads.availability,
      payload,
    })
  },

  // Price books related apis
  async [LOAD_PRICE_BOOKS](ctx) {
    await kpRequest({ ...kpParams(kpEndpoint.catalog.pricebook.get) })
      .then(res => {
        ctx.commit(SET_PRICE_BOOKS, res?.data?.data || [])
      })
      .catch(err => {
        console.error(err)
      })
  },
  async [GET_PRICE_BOOK](ctx, collectionId = null) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.pricebook.getByCollectionId, collectionId),
    })
  },
  async [CREATE_PRICE_BOOK](ctx, { payload = {}, collectionId = null }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.pricebook.create, collectionId),
      payload,
    })
  },
  async [IMPORT_PRICE_BOOK](
    ctx,
    { payload = {}, collectionId = null, priceBookId = null },
  ) {
    // Explicitly check if priceBookId exists and is truthy
    const hasPriceBookId = priceBookId && priceBookId !== null && priceBookId !== undefined

    if (hasPriceBookId) {
      // Individual price book import - when priceBookId is provided
      // Works with order selection flow - orderIds are included in payload if provided
      return await kpRequest({
        ...kpParams(
          kpEndpoint.catalog.pricebook.import,
          collectionId,
          priceBookId,
        ),
        payload,
      })
    } else {
      // Master price book import - when priceBookId is not provided
      // Works with order selection flow - orderIds are included in payload if provided
      return await kpRequest({
        ...kpParams(
          kpEndpoint.catalog.pricebook.importMasterFile,
          collectionId,
        ),
        payload,
      })
    }
  },
    async [IMPORT_SEGMENTATION](ctx, { payload = {}, collectionId = null, segmentationId = null }) {
    return await kpRequest({
      ...kpParams(segmentationId ? kpEndpoint.catalog.segmentation.import : kpEndpoint.catalog.segmentation.importMasterFile, collectionId, segmentationId),
      payload,
    })
  },
  async [DOWNLOAD_MASTER_PRICEBOOK](ctx, { payload = {} }) {
    return await kpRequest({
      ...kpEndpoint.catalog.pricebook.exportMasterFile,
      payload,
    })
  },
  // Currency books related apis
  async [UPDATE_CURRENCIES](ctx, { collectionId = null, payload = {} }) {
    return await kpRequest({
      ...kpParams(
        kpEndpoint.catalog.currencybook.updateCurrencies,
        collectionId,
      ),
      payload,
    })
  },
  async [EXPORT_CURRENCIES](ctx, { collectionId = null, currency = null }) {
    let requestUrl = ''
    if (currency) {
      requestUrl = kpParams(
        kpEndpoint.catalog.currencybook.exportCurrencies,
        collectionId,
        currency,
      )
    } else {
      requestUrl = kpParams(
        kpEndpoint.catalog.currencybook.exportMasterCurrencies,
        collectionId,
      )
    }
    return requestUrl
  },
  async [IMPORT_CURRENCIES](ctx, { params = {}, payload = {} }) {
    let requestUrl = ''
    if (params?.currency) {
      requestUrl = kpParams(
        kpEndpoint.catalog.currencybook.importCurrencies,
        params.collectionId,
        params.currency,
      )
    } else {
      requestUrl = kpParams(
        kpEndpoint.catalog.currencybook.importMasterCurrencies,
        params.collectionId,
      )
    }
    return await kpRequest({ ...requestUrl, payload })
  },

  async [SYNC_COLLECTION_WITH_SHOPIFY](ctx, collectionId = null) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.shopifySync, collectionId),
    })
  },

  async [CREATE_SEGMENTATION](ctx, { payload = {}, collectionId = null }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.segmentation.create, collectionId),
      payload,
    })
  },
  async [GET_SEGMENTATION_BOOKS](ctx, collectionId = null) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.segmentation.get, collectionId),
    })
  },
  async [EXPORT_SEGMENTATION](ctx, { payload = {}, segmentationId = null }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.segmentation.export, segmentationId),
      payload,
    })
  },
  async [DELETE_SEGMENTATION_BOOK](ctx, { segmentationId = null }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.segmentation.delete, segmentationId),
    })
  },
  async [RENAME_SEGMENTATION](ctx, { segmentationId = null, payload = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.segmentation.rename, segmentationId),
      payload,
    })
  },

  async [DOWNLOAD_MASTER_SEGMENTATION_BOOK](ctx, { payload = {} }) {
    return await kpRequest({
      ...kpEndpoint.catalog.segmentation.exportMasterFile,
      payload,
    })
  },
  async [DELETE_PRICEBOOK](ctx, { priceBookId = null }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.pricebook.delete, priceBookId),
    })
  },
  async [RENAME_PRICEBOOK](ctx, { priceBookId = null, payload = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.catalog.pricebook.rename, priceBookId),
      payload,
    })
  },
}

export default {
    actions,
    state,
    mutations,
}
